import {
    CategoryFinancial,
    DishFinancial,
    FinanceServiceDetails,
    OrderFinance,
    PaymentTotalBreakdownDto,
    PaymentTransactionDto,
    RestaurantFinance,
    RestaurantPaymentReportDTO,
} from 'api/models';
import { PaymentTransaction, RestaurantPaymentReport } from './interfaces';

export const createFinanceServiceDetails = (): FinanceServiceDetails => ({
    totalItems: 0,
    totalAmount: 0,
});

export const createFinanceDish = (): DishFinancial => ({
    name: '',
    homeDelivery: createFinanceServiceDetails(),
    takeAway: createFinanceServiceDetails(),
    dineIn: createFinanceServiceDetails(),
    totalItems: 0,
    totalAmount: 0,
});

export const createFinanceCategory = (): CategoryFinancial => ({
    name: '',
    homeDelivery: createFinanceServiceDetails(),
    takeAway: createFinanceServiceDetails(),
    dineIn: createFinanceServiceDetails(),
    totalItems: 0,
    totalAmount: 0,
    dishes: [],
});

export const createOrdersFinance = (): OrderFinance => ({
    id: '',
    createDate: '',
    service: '',
    totalAmount: 0,
    cancelled: false,
});

export const createRestaurantFinanceSales = (): RestaurantFinance => ({
    categories: [],
    orders: [],
    totalAmount: 0,
    totalOrders: 0,
    itemsSold: 0,
    avgOrderAmount: 0,
    totalCancellations: 0,
    topServiceName: null,
    topServicePercent: 0,
    categoriesTotals: createFinanceCategory(),
    paidStorno: {
        count: 0,
        totalAmount: 0,
    },
    refundsAmount: 0,
});

const createPaymentTransaction = (dto: PaymentTransactionDto): PaymentTransaction => ({
    id: dto.id,
    paymentDate: dto.paymentDate,
    method: dto.method,
    amount: dto.amount,
    tipAmount: dto.tipAmount,
    transactionCount: dto.transactionCount,
});

const createPaymentTotalBreakdown = (dto?: PaymentTotalBreakdownDto): PaymentTotalBreakdownDto => ({
    amount: dto?.amount ?? 0,
    sharePercent: dto?.sharePercent ?? 0,
    transactionCount: dto?.transactionCount ?? 0,
});

export const createRestaurantPaymentReport = (
    dto?: RestaurantPaymentReportDTO
): RestaurantPaymentReport => ({
    fromDate: new Date(dto?.fromDate ?? 0),
    toDate: new Date(dto?.toDate ?? 0),
    totalAmount: dto?.totalAmount ?? 0,
    totalTransactionCount: dto?.totalTransactionCount ?? 0,
    byCash: createPaymentTotalBreakdown(dto?.byCash),
    byCard: createPaymentTotalBreakdown(dto?.byCard),
    byDebtor: createPaymentTotalBreakdown(dto?.byDebtor),
    byTwint: createPaymentTotalBreakdown(dto?.byTwint),
    totalTipsAmount: dto?.totalTipsAmount ?? 0,
    payments: dto?.payments ?? [],
    transactions: (dto?.transactions ?? []).map(createPaymentTransaction),
    refunds: dto?.refunds ?? [],
});
